// Must stay aligned with backend event_manage temporal checks (views.py):
// edits blocked when event.start_datetime <= now.
export function canEditEvent(event) {
  if (!event?.start_datetime) return false;
  return new Date(event.start_datetime).getTime() > Date.now();
}

export function isRecurringEvent(event) {
  return !!(event?.is_recurring || event?.series_id);
}

export function formatRecurrenceText(event) {
  if (!isRecurringEvent(event)) return null;
  const rule = (event.recurrence_rule || '').toLowerCase();
  if (!rule) return 'Recurring';

  const getDayOfWeek = () => {
    if (!event.start_datetime) return '';
    const days = ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays'];
    return days[new Date(event.start_datetime).getDay()];
  };

  if (rule === 'daily') return 'Daily';
  if (rule === 'weekly') { const d = getDayOfWeek(); return d ? `Weekly · ${d}` : 'Weekly'; }
  if (rule === 'biweekly') { const d = getDayOfWeek(); return d ? `Bi-weekly · ${d}` : 'Bi-weekly'; }
  if (rule === 'monthly') return 'Monthly';
  return 'Recurring';
}
